export default __webpack_public_path__ + "static/media/Gilroy-Semibold.5b042906.woff";